import { jsx as _jsx } from "react/jsx-runtime";
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetConsumerApplicationsV1LocationsLocationIdLenderTermsLenderNameQuery } from 'consumer-applications-v1-api';
import TermsAgreement from './TermsAgreement';
const TermsAgreementShell = ({ lenderName, locationId, }) => {
    // Narrow the free-form `lenderName` prop to the codegen'd union via a runtime
    // guard so TS infers the correct arg type (no cast) and an unexpected value
    // skips the query instead of firing a request with an invalid lender name.
    const isValidLender = lenderName === 'AFF' || lenderName === 'ADS';
    const { data: lenderTerms } = useGetConsumerApplicationsV1LocationsLocationIdLenderTermsLenderNameQuery(locationId && isValidLender ? { locationId, lenderName } : skipToken);
    return _jsx(TermsAgreement, { terms: lenderTerms?.terms ?? null });
};
export default TermsAgreementShell;
